<template>
  <div class="bg-white dark:bg-gray-900 px-6 py-8 md:p-8 rounded-lg shadow-2xl">
    <slot />
  </div>
</template>
